const EnfermedadPreexistenteTipos = {
    data: {
        ERROR: 13,
        INGRESAR_ENFERMEDAD: 14,
        INGRESAR_ENFERMEDAD_SOCIO: 2300040401,
        OBTENER_ENFERMEDADES_PRE_EXISTENTES_PENDIENTE: 123456,
        OBTENER_ENFERMEDADES_PRE_EXISTENTES_EXITO: 1234598,
    }
}
export default EnfermedadPreexistenteTipos;